import React, {Component} from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import moment from 'moment';
import {fromBackendDate} from '../../../../utils/DateUtils';
import CreditCard from "./CreditCard";
import Modal from '../../../../components-new/ui/Modal';
import Translate, {t} from "../../../../components/Translate";

import {
    bindCardRequest,
    changeAutoPayment,
    deactivateBinding,
    requestChangeActiveCard
} from '../../../../services/company/api';
import RadioButton from "../../../../components/radio-button";
import BlueButton from "../../../../components-new/buttons/BlueButton";
import SilverButton from "../../../../components-new/buttons/SilverButton";
import config from "../../../../config";
import {generalModalStyles} from "../../../../utils/General";
import PlusIcon from "../../../../assets/icons/PlusIcon";
import Colors from "../../../../utils/Colors";
import Switch from "../../../../components-new/form/Switch";
import DeleteIcon from "../../../../assets/icons/DeleteIcon";

const styles = {
    tariff: {
        description: {
            // marginLeft: '60px',
            marginTop: '27px',
        },
        name: {
            color: Colors.blueDark,
            fontSize: '18px',
            fontWeight: 'bold',
        },
        contentSpace: {
            marginBottom: '20px',
            display: 'flex',
            gap: '20px',
            alignItems: 'center'
        },
    },
    trashButtonStyle: {
        width: '50px',
        height: '50px',
        border: '1px solid #E0E0E0',
        backgroundColor: 'rgb(225, 78, 82)',
        borderRadius: 0,
        cursor: 'pointer',
        margin: '10px 10px',
    },
};

class BillingComponent extends Component {
    constructor(props) {
        super(props);
        const {company} = this.props;
        this.state = {
            isBindCardModalOpen: false,
            isDeleteCardModalOpen: false,
            cardHolderIdToBeDeleted: '',
            isOpenModal: this.props.isOpenModal,
            company
        };
    }

    paymentFee = (plan) => {
        const {company, user} = this.props;
        const currency = company.country === 'am' ? '֏' : '$';
        if (plan.tariffStatus === 'TRIAL') {
            return 'Free trial';
        }
        if (plan.tariffStatus === 'ACTIVE' || plan.tariffStatus === 'DRAFT_PAID') {
            return `${plan.price} ${currency} (${t({text: "paid", user})})`;
        }
        return `${plan.price} ${currency} (${t({text: "notPaid", user})})`;
    };

    planTimeName = (tabId, plan) => {
        const {user} = this.props;
        return (tabId === 1 ? (plan.tariffStatus === 'PAYMENT_REQUIRED' ? `${t({
            text: "expiresOn",
            user
        })}:` : `${t({text: "expiresOn", user})}:`) : `${t({text: "startsOn", user})}:`);
    }

    format = (tabId, plan) => {
        const {user} = this.props;
        const dateTime = tabId === 1 ? plan.endDate : plan.startDate;
        const localDate = fromBackendDate(dateTime);
        if (Number.isNaN(localDate.getTime())) return '—';
        const date = moment(localDate).format('DD.MM.YYYY');
        const time = moment(localDate).format('hh:mm');
        return `${date} ${t({text: "at", user})} ${time}`;
    };

    openBindCardModal = () => {
        this.setState({
            isBindCardModalOpen: true,
        });
    };

    openDeleteBindingCardModal = (cardHolderId) => {
        this.setState({
            cardHolderIdToBeDeleted: cardHolderId,
            isDeleteCardModalOpen: true,
        });
    };

    closeDeleteBindingCardModal = () => {
        this.setState({isDeleteCardModalOpen: false, cardHolderIdToBeDeleted: ''});
    };

    requestNewCardBinding = () => {
        bindCardRequest()
            .then((response) => {
                if (response.status === 201) {
                    window.location.href = response.data;
                } else {
                    alert("Something went wrong");
                }
            })
            .catch((error) => {
                alert(error)
            });
        this.setState({
            isBindCardModalOpen: false,
        });
    };

    confirmDeleteBindingCardModal = () => {
        const {cardHolderIdToBeDeleted, company} = this.state;
        this.closeDeleteBindingCardModal();
        deactivateBinding(cardHolderIdToBeDeleted)
            .then(() => {
                company.bindingCards = company.bindingCards.filter(card => card.cardHolderId !== cardHolderIdToBeDeleted);
                this.setState({
                    company,
                })
            });
    };

    closeBindCardModal = () => {
        this.setState({
            isBindCardModalOpen: false,
        });
    };

    changeActiveCard = (cardHolderId) => {
        requestChangeActiveCard(cardHolderId)
            .then((response) => {
                this.setState({
                    company: response.data
                });
            });
    };

    requestChangeAutoPayment = () => {
        const {company} = this.state;
        const autoPaymentEnabled = company.autoPaymentEnabled;
        changeAutoPayment(!autoPaymentEnabled)
            .then((response) => {
                this.setState({
                    company: response.data
                });
            });
    };

    render() {
        const {plan, tabId, onPayClick, user} = this.props;
        const {isBindCardModalOpen, isDeleteCardModalOpen, company} = this.state;
        const bindingCards = company.bindingCards;
        const activeCardHolderId = company.activeCardHolderId;
        const autoPaymentEnabled = company.autoPaymentEnabled;
        return (
            <div>
                <div style={styles.tariff.description}>
                    <p style={[styles.tariff.name, styles.tariff.contentSpace]}>
                        {plan.tariffPackage.name.en}
                        {' '}
                        (+
                        {' '}
                        {plan.additionalOperators}
                        {' '}
                        operators
                        / +
                        {' '}
                        {plan.additionalClients}
                        {' '}
                        clients)
                    </p>
                    <p style={styles.tariff.contentSpace}>
                        <span
                            style={{fontWeight: 'bold'}}
                        >
                          {this.planTimeName(tabId, plan)}
                        </span>
                        {' '}
                        {plan.tariffStatus !== 'PAYMENT_REQUIRED' && this.format(tabId, plan)}
                    </p>


                    {/* todo deposit logic*/}
                    <p style={styles.tariff.contentSpace}>
                            <span
                                style={{fontWeight: 'bold'}}
                            >
                              {t({text: "deposit", user})}:
                            </span>
                        {' '}
                        {plan.company.credit}
                    </p>

                    <p style={styles.tariff.contentSpace}>
                            <span
                                style={{fontWeight: 'bold'}}
                            >
                              {t({text: "fee", user})}:
                            </span>
                        {' '}
                        {this.paymentFee(plan)}
                    </p>

                    <div>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <h3>{t({text: "bindingCards", user})}</h3>
                            <SilverButton
                                width={'40px'}
                                height={'40px'}
                                onClick={this.openBindCardModal}
                                styles={{padding: '10px 0 10px 0', marginLeft: '10px'}}
                                className="common-action-button"
                            >
                                <PlusIcon height={25} width={25}/>
                            </SilverButton>
                        </div>


                        {
                            bindingCards && bindingCards.map((item, key) => (
                                <div style={{display: 'flex', marginBottom: '20px'}} key={key}>
                                    <div onClick={() => this.changeActiveCard(item.cardHolderId)}
                                         style={{padding: '24px 18px 0 0'}}>
                                        <RadioButton selected={activeCardHolderId === item.cardHolderId}/>
                                    </div>
                                    <CreditCard clientName={item.clientName} cardNumber={item.cardNumber}/>
                                    <button type="button"
                                            onClick={() => this.openDeleteBindingCardModal(item.cardHolderId)}
                                            style={styles.trashButtonStyle}>
                                        <DeleteIcon width="16" height="20" fill="#FFFFFF"/>
                                    </button>
                                </div>
                            ))
                        }

                        {isBindCardModalOpen &&
                            <Modal closeTimeoutMS={config.closeTimeoutMS}
                                   isOpen={isBindCardModalOpen}
                                   onRequestClose={this.closeBindCardModal}
                                   onCancel={this.closeBindCardModal}
                                   onSubmit={this.requestNewCardBinding}
                                   title={<Translate text="bindCard"/>}
                                   style={generalModalStyles.confirmModalStyles}
                            >
                                <p style={{
                                    color: '#09183A',
                                    fontSize: '18px',
                                    textAlign: 'center',
                                    margin: '40px',
                                }}
                                >
                                    <Translate text="bindCardText"/>
                                </p>
                            </Modal>
                        }

                        <Modal
                            closeTimeoutMS={config.closeTimeoutMS}
                            isOpen={isDeleteCardModalOpen}
                            onCancel={this.closeDeleteBindingCardModal}
                            onSubmit={this.confirmDeleteBindingCardModal}
                            header={<h2 style={{margin: 0, fontSize: '18px'}}><Translate text="delete"/></h2>}
                            style={generalModalStyles.confirmModalStyles}
                        >
                            <Translate text="areYouSureYouWantToProceed"/>
                        </Modal>

                    </div>
                    {
                        tabId === 1
                            ? <div/>
                            :
                            (
                                <div>
                                    {/*todo open card*/}
                                    <div style={styles.tariff.contentSpace}>
                                        <span>
                                          <span style={{fontWeight: 'bold'}}>
                                            <Translate text={'autoPayment'}/>:
                                          </span>
                                        </span>

                                        <Switch
                                            checked={autoPaymentEnabled}
                                            onChange={this.requestChangeAutoPayment}
                                        />
                                    </div>
                                </div>
                            )
                    }
                    {
                        plan.tariffStatus === 'PAYMENT_REQUIRED'
                            ? (
                                <div style={styles.tariff.contentSpace}>
                                    <BlueButton width={'115px'} type={'button'} onClick={onPayClick}
                                                children={<Translate text={'pay'}/>}/>
                                </div>
                            ) : <div/>
                    }
                </div>
            </div>
        );
    }
}

BillingComponent.propTypes = {
    tabId: PropTypes.number.isRequired,
    company: PropTypes.object.isRequired,
    plan: PropTypes.object.isRequired,
};

export default Radium(BillingComponent);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/billing/BillingComponent.jsx